import { render } from "./inspectionDetails.vue?vue&type=template&id=b3ef8022&scoped=true"
const script = {}

import "./inspectionDetails.vue?vue&type=style&index=0&id=b3ef8022&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ef8022"]])

export default __exports__